// Dependencies
import { useState } from 'react';
import './HowToPay60SixtyTips.css';

const HowToPay60SixtyTips = () => {
	const [selectedTip, setSelectedTip] = useState(null);
	const tips = [
		{
			id: 'top-up-your-voucher-account',
			thumbnail: 'https://cms.computicket.com/api/assets/mma/6bf73737-62ca-4fc6-b5de-d616037146fb/top-up.png?version=0',
			cardImage: 'https://cms.computicket.com/api/assets/mma/7962a785-884e-4541-8e57-d37d7cbdf02e/top-up-your-voucher-account-min.png?version=0',
			alt: 'how to top-up your voucher account',
            download: 'https://www.youtube.com/embed/faclOIRQKO4'
		},
		{
			id: 'link-your-xtra-savings-card',
			thumbnail: 'https://cms.computicket.com/api/assets/mma/3ac53408-ef5e-40ae-9b0b-4e63007c5e9a/save.png?version=0',
			cardImage: 'https://cms.computicket.com/api/assets/mma/c242718d-0fda-43d6-b539-ed07362742df/link-your-xtra-savings-card-min.png?version=0',
			alt: 'how to link your xtra savings card',
            download: 'https://www.youtube.com/embed/YXbVbrijN8A'
		}
	];

	const handleThumbnailClick = (tip) => {
		setSelectedTip(tip);
	};

	const closeModal = () => {
		setSelectedTip(null);
	};

	const handleModalBackdropClick = (e) => {
		if (e.target === e.currentTarget) {
			closeModal();
		}
	};

        const downloadImage = (url, filename) => {
        fetch(url)
            .then(response => response.blob())
            .then(blob => {
                const link = document.createElement('a');
                link.href = URL.createObjectURL(blob);
                link.download = filename;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            })
            .catch(error => console.error('Error downloading image:', error));
    };

	return (
		<div className="sixty60-tips-section">
			<div className="sixty60-tips-header">
				<div className="sixty60-tips-text-content">
					<h2 className="sixty60-tips-title">Tip</h2>
					<p className="sixty60-tips-description">
						For the best experience, ensure you have a Money Market Account and a linked Xtra Savings card. If not, get an Xtra Savings card in-store and easily link it to your account. 
					</p>
				</div>
				<div className="sixty60-tips-image-content">
					<img 
						src="https://cms.computicket.com/api/assets/mma/cbb3ca85-e9cf-4036-a985-f1d1c5befbaf/card-lady-min.png?version=0"
						alt="Woman holding Xtra Savings cards"
						className="sixty60-tips-header-image"
					/>
				</div>
			</div>
			{/* Top-up Section */}
			<div className="sixty60-topup-section">	
				<h3 className="sixty60-topup-title">How to top-up your voucher account</h3>
				<div className="sixty60-topup-description">
					You can deposit money into your voucher account in 3 easy ways:
				</div>

				<div className="sixty60-topup-methods">
					<div className="sixty60-topup-method">
						<div className="sixty60-method-number">1</div>
						<h4 className="sixty60-method-title">Cash<br/>in-store</h4>
						<p className="sixty60-method-description">
							You can deposit cash into your account at any till in one of these stores
						</p>
						<div className="sixty60-method-logos">
							<img 
								src="https://cms.computicket.com/api/assets/mma/75d09dd5-1eb9-4b57-aa2b-64d53e59cb7c/shoprite-brands.png?version=0"
								alt="Shoprite, Checkers, Usave"
								className="sixty60-brands-logo"
							/>
						</div>
					</div>

					<div className="sixty60-topup-method">
						<div className="sixty60-method-number">2</div>
						<h4 className="sixty60-method-title">EFT<br/>with Ozow</h4>
						<p className="sixty60-method-description">
							Deposit money into your voucher account with Ozow instant EFT via the Shoprite app
						</p>
						<div className="sixty60-method-logos">
							<img 
								src="https://cms.computicket.com/api/assets/mma/3a7d8665-1c86-4f80-952b-d635206c34a3/ozow.png?version=0"
								alt="Ozow"
								className="sixty60-ozow-logo"
							/>
						</div>
					</div>

					<div className="sixty60-topup-method">
						<div className="sixty60-method-number">3</div>
						<h4 className="sixty60-method-title">Using a bank card<br/>on Computicket</h4>
						<p className="sixty60-method-description">
							Visit computicket.com and use your credit card to top up your voucher account.
						</p>
						<div className="sixty60-method-logos">
							<img 
								src="https://cms.computicket.com/api/assets/mma/a836362b-f0bf-42fb-aba7-1ddf4177ac34/computicket.png?version=0"
								alt="Computicket"
								className="sixty60-computicket-logo"
							/>
						</div>
					</div>
				</div>
			</div>
			<div className="sixty60-tips-thumbnails">
				{tips.map((tip) => (
					<div
						key={tip.id}
						className="sixty60-tip-thumbnail-wrapper"
						onClick={() => handleThumbnailClick(tip)}
					>
						<img
							src={tip.thumbnail}
							alt={tip.alt}
							className="sixty60-tip-thumbnail"
						/>
					</div>
				))}
			</div>



			{/* Modal */}
			{selectedTip && (
				<div
					className="sixty60-tips-modal-backdrop"
					onClick={handleModalBackdropClick}
				>
					<div className="sixty60-tips-modal-content">
						<button
							className="sixty60-tips-modal-close"
							onClick={closeModal}
							aria-label="Close modal"
						>
							✕
						</button>
						<iframe
							className="sixty60-tips-modal-video"
							src={`${selectedTip.download}`}
							title={selectedTip.alt}
							width="100%"
							height="100%"
							alt={selectedTip.alt}
							allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                			allowFullScreen
						/>
					</div>

					
				</div>
			)}
		</div>
	);
};

export default HowToPay60SixtyTips;
